import { RootState } from '../../../store';

export type TDocument = IDietTherapy;

export const stateToDietProps = (state: RootState): Pick<IJWTBody, 'visitreason'> => {
  return {
    visitreason: state.session.data?.visitreason ?? '',
  };
};
